import React, { useCallback, useRef, useState } from 'react';

let toastIdSeq = 0;

/**
 * 화면 우측 상단에 쌓이는 가벼운 토스트 알림 훅. 여러 페이지에서 재사용할 수 있도록
 * 페이지별 상태(useState)만 감싸뒀다 - 전역 컨텍스트/프로바이더 없이, 알림이 필요한
 * 페이지에서 이 훅을 부르고 <ToastStack /> 을 함께 렌더링하면 된다.
 *
 * const { toasts, pushToast } = useToasts();
 * ...
 * <ToastStack toasts={toasts} onDismiss={removeToast} />
 */
export function useToasts(autoDismissMs = 5000) {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  const removeToast = useCallback((id) => {
    setToasts((list) => list.filter((t) => t.id !== id));
    clearTimeout(timers.current[id]);
    delete timers.current[id];
  }, []);

  const pushToast = useCallback((message, type = 'info') => {
    const id = ++toastIdSeq;
    setToasts((list) => [...list, { id, message, type }]);
    timers.current[id] = setTimeout(() => removeToast(id), autoDismissMs);
  }, [autoDismissMs, removeToast]);

  return { toasts, pushToast, removeToast };
}

/** 클릭하면 즉시 닫히고, 그렇지 않으면 useToasts 의 autoDismissMs 이후 자동으로 사라진다. */
export default function ToastStack({ toasts, onDismiss }) {
  if (!toasts || toasts.length === 0) return null;
  return (
    <div className="toast-stack">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`toast toast-${t.type || 'info'}`}
          onClick={() => onDismiss && onDismiss(t.id)}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
